import { messageLevels } from '../constants';
export var getMessageLevel = function getMessageLevel(_ref) {
  var level = _ref.level,
      error = _ref.error,
      success = _ref.success,
      warning = _ref.warning;

  if (level === messageLevels.error || error) {
    return 'error';
  }

  if (level === messageLevels.success || success) {
    return 'success';
  }

  if (level === messageLevels.warning || warning) {
    return 'warning';
  }

  return 'info';
};